module.exports = __webpack_public_path__ + "static/media/league-manager-icon-large.9e4d7c66.svg";